import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
  useTheme,
} from "@mui/material";
import { X } from "lucide-react";
import { WizardResetConfirm } from "../types";

interface WizardResetDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  copy: WizardResetConfirm;
}

const WizardResetDialog: React.FC<WizardResetDialogProps> = ({
  open,
  onClose,
  onConfirm,
  copy,
}) => {
  const theme = useTheme();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="xs"
      PaperProps={{
        sx: {
          backgroundColor: theme.palette.background.default,
          borderRadius: "16px",
          border: `1px solid ${theme.palette.divider}`,
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "20px 24px 8px",
          color: theme.palette.text.primary,
        }}
      >
        <Typography sx={{ fontSize: "18px", fontWeight: 700 }}>
          {copy.title}
        </Typography>
        <IconButton
          onClick={onClose}
          aria-label="close"
          sx={{ color: theme.palette.text.primary }}
        >
          <X size={20} />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ padding: "8px 24px 16px" }}>
        <Typography
          sx={{
            fontSize: "14px",
            color: theme.palette.text.primary,
            lineHeight: 1.5,
          }}
        >
          {copy.description}
        </Typography>
      </DialogContent>

      <DialogActions sx={{ padding: "8px 24px 20px", gap: 1 }}>
        <Button
          onClick={onClose}
          variant="text"
          sx={{
            textTransform: "none",
            color: theme.palette.text.primary,
            fontWeight: 600,
          }}
        >
          {copy.cancelLabel}
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          sx={{
            textTransform: "none",
            fontWeight: 700,
            borderRadius: "8px",
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
            "&:hover": { backgroundColor: theme.palette.primary.dark },
          }}
        >
          {copy.confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default WizardResetDialog;
